module.exports = __webpack_public_path__ + "img/Asalto_Atraco.b7c23d24.svg";